import React from 'react';
import { useSelector } from 'react-redux';
import { GeoJSON } from 'react-leaflet';
import { displayStatuses } from './locationData';
import { UavMapElement } from 'views/Restaurant/components/UavMapElement';
import { Pilots } from '../../Pilots/Pilots';
import { LOD } from '../LOD';

import { OrdersMapElement } from '../../Orders/OrdersMapElement';
import { selectShowSitl } from 'selectors/liveAircraftSelectors';
import { RootState } from '../../../../../store/configureStore';

export const Locations = props => {
  const uavs = useSelector((state: RootState) => state.liveAircraft.liveData);
  const geofences = useSelector((state: RootState) => state.geofences.geofences);
  const showSitl = useSelector(selectShowSitl);
  const ordersToFilter = useSelector((state: RootState) => state.orders.ordersToFilter);

  const orders = ordersToFilter?.filter(order => {
    const isPending = displayStatuses.includes(order.status);
    return isPending;
  });

  const pilotDataArr = Object.values(uavs)
    .filter((uav: any) => {
      if (showSitl) {
        return true;
      } else {
        return !uav?.sitl;
      }
    })
    .map((uav: any) => {
      return { uavId: uav.uavId, pilotInfo: uav?.pilotInfo, uav };
    });

  return (
    <div>
      <>
        <UavMapElement
          sitl={showSitl}
          key="UavMapElement"
          uavData={uavs}
          geotunnel
        />
        <Pilots sitl={showSitl} p1 p2 key="Pilots" data={pilotDataArr} />
        <OrdersMapElement key={'OrdersMapElement'} orders={orders} />
      </>
      <div key={'geofences'}>
        {geofences?.map((geofence, i) => (
          <GeoJSON
            data={geofence.geoJson}
            style={{ fill: false, color: 'gray' }}
            key={`geofence-${geofence.id}-${i}`}
          />
        ))}
      </div>
      <LOD key="LODLow" zoom={props.zoom} floor={2} ceiling={13}>
        <OrdersMapElement orders={orders} />
      </LOD>
    </div>
  );
};
